import React from 'react';
import { IonItem, IonItemGroup, IonLabel, IonNote, IonTextarea, IonToggle } from '@ionic/react';

const minReasonLength = 4;
const maxReasonLength = 500;

export function FlagChecklistPanel({
    flagged,
    reason,
    isReadOnly,
    onToggle,
    onReasonChange,
}) {
    return (
        <IonItemGroup>
            <IonItem>
                <IonLabel>Flag for Review</IonLabel>
                <IonToggle
                    checked={ flagged }
                    disabled={ isReadOnly }
                    onIonChange={ e => onToggle(e.detail.checked) }
                />
            </IonItem>

            { flagged &&
                <IonItem>
                    <IonLabel position="floating">Message to the Coordinator</IonLabel>
                    <IonTextarea
                        readonly={ isReadOnly }
                        disabled={ isReadOnly }
                        placeholder="Enter a reason for flagging this checklist for review..."
                        value={ reason }
                        debounce={ 250 }
                        minLength={ minReasonLength }
                        maxLength={ maxReasonLength }
                        onIonChange={ e => onReasonChange(e.detail.value ?? '') }
                    />
                    <InformationMessage readonly={ isReadOnly } />
                </IonItem>
            }
        </IonItemGroup>
    );
}

function InformationMessage({ readonly }) {
    if (readonly) {
        return (
            <IonNote>
                This checklist has been flagged for review. The flag and reason can no longer be modified.
            </IonNote>
        );
    }
    return (
        <IonNote style={ { margin: '0.25rem 0' } }>Once you save this checklist, the flag and your reason cannot be changed or removed.</IonNote>
    );
}
